import clsx from 'clsx';
import i18n from 'i18n-react';
import { isNil } from 'lodash-es';

import c from './_profileRooms.module.scss';

export interface ProfileRoomsProps {
  numberOfRooms?: number | string | null;
}

function isNumeric(value: number | string): boolean {
  return typeof value === 'number' || (value.trim() !== '' && !Number.isNaN(Number(value)));
}

export function ProfileRooms({ numberOfRooms }: ProfileRoomsProps) {
  // The API stores a blank room count as 0, so 0 is treated as "not set".
  if (isNil(numberOfRooms) || numberOfRooms.toString().trim() === '' || Number(numberOfRooms) === 0) return null;

  return (
    <div className="profile-rooms">
      <div className={clsx('profile-rooms__title', c.title)}>
        {i18n.translate('directoryProfileView.numberOfRoomsTitle')}
      </div>
      <p>
        {isNumeric(numberOfRooms)
          ? i18n.translate('directoryProfileView.roomsCount', { count: Number(numberOfRooms) })
          : numberOfRooms}
      </p>
    </div>
  );
}
